import { GlobalConstantsTexte } from 'globales-projekt-angular';

export class ConstantsTexte {
  static readonly ANWENDUNGSNAME: string =
    'Betriebswirtschaftliche Ausrichtung';

  static readonly KEINE_GUELTIGER_DATEITYP_FUER_DATEI: string =
    'Der Datei-Typ der Datei(en) ' +
    GlobalConstantsTexte.TEXT_ERSETZUNG_EINS +
    '\nwird nicht unterstützt.\nEs werden nur die Typen ' +
    GlobalConstantsTexte.TEXT_ERSETZUNG_ZWEI +
    ' unterstützt.';

  static readonly CHART_BETRAG_BEREINIGT: string = 'SO Betrag bereinigt';
  static readonly CHART_BETRAG_BRUTTO: string = 'SO Betrag brutto';

  static readonly CHART_STANDARDOUTPUT_IN_EURO: string = 'Standardoutput in €';
  static readonly CHART_ANTEIL_SOC_MERKMALE: string = 'Anteil SOC Merkmale';
  static readonly CHART_SO_BETRIEB: string = 'SO Betrieb';
  static readonly CHART_ZWEI_DREI_SO_BETRIEB: string = '2/3 SO Betrieb';
  static readonly CHART_EINS_DREI_SO_BETRIEB: string = '1/3 SO Betrieb';
}
